import firebase from "firebase/compat/app"; // Use compat version
import "firebase/compat/messaging"; // Use compat version

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
};

let messaging: firebase.messaging.Messaging | null = null;

try {
  if (typeof window !== 'undefined' && 
      'Notification' in window && 
      'serviceWorker' in navigator && 
      firebase.messaging.isSupported()) {
    
    // Initialize Firebase
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }
    
    // Initialize Messaging
    messaging = firebase.messaging();
  }
} catch (error) {
  console.error('Firebase initialization error', error);
}

export { messaging };